/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CheckinOrderCommand } from '../model';
// @ts-ignore
import type { CheckoutOrderCommand } from '../model';
// @ts-ignore
import type { DeleteOrdersCommand } from '../model';
// @ts-ignore
import type { UndoAllowOrderEntryCommand } from '../model';
// @ts-ignore
import type { UndoCheckoutOrderCommand } from '../model';
/**
 * AdminActionsApi - axios parameter creator
 */
export const AdminActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckinOrderCommand} [checkinOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkin: async (checkinOrderCommand?: CheckinOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/AdminActions/Checkin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkinOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckoutOrderCommand} [checkoutOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout: async (checkoutOrderCommand?: CheckoutOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/AdminActions/Checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteOrdersCommand} [deleteOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByIds: async (deleteOrdersCommand?: DeleteOrdersCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/AdminActions/DeleteByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOrdersCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UndoAllowOrderEntryCommand} [undoAllowOrderEntryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCheckIn: async (undoAllowOrderEntryCommand?: UndoAllowOrderEntryCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/AdminActions/UndoCheckIn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoAllowOrderEntryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UndoCheckoutOrderCommand} [undoCheckoutOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCheckout: async (undoCheckoutOrderCommand?: UndoCheckoutOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/AdminActions/UndoCheckout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(undoCheckoutOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminActionsApi - functional programming interface
 */
export const AdminActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckinOrderCommand} [checkinOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkin(checkinOrderCommand?: CheckinOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkin(checkinOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminActionsApi.checkin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CheckoutOrderCommand} [checkoutOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkout(checkoutOrderCommand?: CheckoutOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkout(checkoutOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminActionsApi.checkout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteOrdersCommand} [deleteOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteByIds(deleteOrdersCommand?: DeleteOrdersCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteByIds(deleteOrdersCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminActionsApi.deleteByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UndoAllowOrderEntryCommand} [undoAllowOrderEntryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoCheckIn(undoAllowOrderEntryCommand?: UndoAllowOrderEntryCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoCheckIn(undoAllowOrderEntryCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminActionsApi.undoCheckIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UndoCheckoutOrderCommand} [undoCheckoutOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoCheckout(undoCheckoutOrderCommand?: UndoCheckoutOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoCheckout(undoCheckoutOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminActionsApi.undoCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminActionsApi - factory interface
 */
export const AdminActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminActionsApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckinOrderCommand} [checkinOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkin(checkinOrderCommand?: CheckinOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkin(checkinOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckoutOrderCommand} [checkoutOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkout(checkoutOrderCommand?: CheckoutOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkout(checkoutOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteOrdersCommand} [deleteOrdersCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteByIds(deleteOrdersCommand?: DeleteOrdersCommand, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteByIds(deleteOrdersCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UndoAllowOrderEntryCommand} [undoAllowOrderEntryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCheckIn(undoAllowOrderEntryCommand?: UndoAllowOrderEntryCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoCheckIn(undoAllowOrderEntryCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UndoCheckoutOrderCommand} [undoCheckoutOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoCheckout(undoCheckoutOrderCommand?: UndoCheckoutOrderCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoCheckout(undoCheckoutOrderCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminActionsApi - object-oriented interface
 */
export class AdminActionsApi extends BaseAPI {
    /**
     * 
     * @param {CheckinOrderCommand} [checkinOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkin(checkinOrderCommand?: CheckinOrderCommand, options?: RawAxiosRequestConfig) {
        return AdminActionsApiFp(this.configuration).checkin(checkinOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckoutOrderCommand} [checkoutOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkout(checkoutOrderCommand?: CheckoutOrderCommand, options?: RawAxiosRequestConfig) {
        return AdminActionsApiFp(this.configuration).checkout(checkoutOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteOrdersCommand} [deleteOrdersCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteByIds(deleteOrdersCommand?: DeleteOrdersCommand, options?: RawAxiosRequestConfig) {
        return AdminActionsApiFp(this.configuration).deleteByIds(deleteOrdersCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UndoAllowOrderEntryCommand} [undoAllowOrderEntryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public undoCheckIn(undoAllowOrderEntryCommand?: UndoAllowOrderEntryCommand, options?: RawAxiosRequestConfig) {
        return AdminActionsApiFp(this.configuration).undoCheckIn(undoAllowOrderEntryCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UndoCheckoutOrderCommand} [undoCheckoutOrderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public undoCheckout(undoCheckoutOrderCommand?: UndoCheckoutOrderCommand, options?: RawAxiosRequestConfig) {
        return AdminActionsApiFp(this.configuration).undoCheckout(undoCheckoutOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

